/**
 * Petite animation de confettis sans dépendance externe.
 * Utilisée pour célébrer le franchissement de l'objectif mensuel
 * ou des podiums dans le classement.
 *
 * Usage : import { fireConfetti } from '@/lib/confetti';
 *         fireConfetti({ origin: 'top' });
 */

const COLORS = ['#21b3a3', '#C89010', '#1a8a7d', '#e0a823', '#5fcabb'];

export interface ConfettiOptions {
  origin?: 'top' | 'center';
  count?: number;
  duration?: number;
}

export function fireConfetti(opts: ConfettiOptions = {}): void {
  const { origin = 'top', count = 80, duration = 2500 } = opts;

  // Container plein écran, par-dessus tout
  const container = document.createElement('div');
  container.style.cssText = `
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 9999;
    overflow: hidden;
  `;
  document.body.appendChild(container);

  const startY = origin === 'top' ? -20 : window.innerHeight / 2;
  const spread = origin === 'top' ? window.innerWidth : window.innerWidth * 0.6;
  const startX0 = origin === 'top' ? 0 : window.innerWidth / 2 - spread / 2;

  for (let i = 0; i < count; i++) {
    const piece = document.createElement('div');
    const size = 6 + Math.random() * 6;
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const startX = startX0 + Math.random() * spread;
    const drift = (Math.random() - 0.5) * 200;
    const rotateEnd = (Math.random() - 0.5) * 720;
    const delay = Math.random() * 300;
    const fallDistance = window.innerHeight + 60;

    piece.style.cssText = `
      position: absolute;
      width: ${size}px;
      height: ${size * 0.6}px;
      background: ${color};
      left: ${startX}px;
      top: ${startY}px;
      transform-origin: center;
      opacity: 0;
      border-radius: 1px;
    `;

    piece.animate(
      [
        { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
        {
          transform: `translate(${drift}px, ${fallDistance}px) rotate(${rotateEnd}deg)`,
          opacity: 0
        }
      ],
      {
        duration,
        delay,
        easing: 'cubic-bezier(0.15, 0.9, 0.4, 1)',
        fill: 'forwards'
      }
    );
    container.appendChild(piece);
  }

  // Nettoyage après l'animation
  setTimeout(() => {
    container.remove();
  }, duration + 500);
}
